import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../config/api.config';
import { ApiResponse } from '../models/api.model';
import {
  UsuarioFormValue,
  UsuariosDataModel,
  UsuariosInfoModel,
} from '../models/usuario.data.model';
import {
  PagedResponse,
  PaginationRequest,
} from '../../shared/data-table-paginado/data-table-paginado.models';

@Injectable({ providedIn: 'root' })
export class UsuarioService {
  private readonly http = inject(HttpClient);
  private readonly resourceUrl = `${API_URL}/usuarios`;

  getUsuariosInfo(): Observable<ApiResponse<UsuariosInfoModel>> {
    return this.http.get<ApiResponse<UsuariosInfoModel>>(`${this.resourceUrl}/informacion`);
  }

  getUsuariosDataPaginada(
    request: PaginationRequest,
  ): Observable<ApiResponse<PagedResponse<UsuariosDataModel>>> {
    let params = new HttpParams().set('page', request.page).set('pageSize', request.pageSize);

    if (request.search?.trim()) params = params.set('search', request.search.trim());
    if (request.status) params = params.set('status', request.status);
    if (request.sortBy) params = params.set('sortBy', request.sortBy);
    if (request.sortDirection) params = params.set('sortDirection', request.sortDirection);

    return this.http.get<ApiResponse<PagedResponse<UsuariosDataModel>>>(
      `${this.resourceUrl}/paginado`,
      { params },
    );
  }

  create(request: UsuarioFormValue): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.resourceUrl}/create`, request);
  }

  update(idUsuario: string, request: UsuarioFormValue): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.resourceUrl}/update/${idUsuario}`, request);
  }

  desactivate(idUsuario: string): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(
      `${this.resourceUrl}/desactivate/${idUsuario}`,
      null,
    );
  }
}
